import cx from 'classnames'
import React, { HTMLProps } from 'react'
import * as styles from '../styles/components/dropdown.module.scss'

export type DropdownOption = {
    id: string
    label: string
}

export type DropDownProps = HTMLProps<HTMLSelectElement> & {
    preselectedOptionId?: string
    options: DropdownOption[]
}

const Dropdown = ({ options, preselectedOptionId, className, ...rest }: DropDownProps) => {
    return (
        <div className={cx(className, styles.container)}>
            <select className={styles.select} {...rest} defaultValue={preselectedOptionId}>
                <option value="" disabled>...</option>
                {options.map((t) => {
                    const id = `opt-${t.id}`
                    return (
                        <option value={t.id} id={id} key={id}>
                            {t.label}
                        </option>
                    )
                },

                )}
            </select>
        </div>
    )
}

export default Dropdown
